import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').QuoteBlock}
 */

const Quote = ({
    name,
    quote
}) => {
    return (
        <div className='module-quote'>
            <div className='layout-container layout-site-outer-padding py-24 sm:py-40 md:py-48'>
                <div className='col-wrapper flex'>

                        {/* Empty left column for layout (4 columns) */}
                        <div className='hidden md:block md:w-1/12 lg:w-2/12 col-padding' />
                    <blockquote className='w-full sm:w-11/12 md:w-10/12 lg:w-7/12 col-padding'>

                        {quote && (
                            <p className='type-style-3 text-main-text-primary'>
                                &ldquo;{quote}&rdquo;
                            </p>
                        )}
                        {name && (
                            <cite className='type-style-eyebrow text-main-text-primary mt-16 not-italic block'>
                                {name}
                            </cite>
                        )}
                    </blockquote>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Quote;
